
export class AzureADUserSummaryModel {
  id: string;
  displayName: string;
  userPrincipalName: string;
  userType: string;
  mail: string;
}
